module.exports = __webpack_public_path__ + "0f640e5c24599312722657dff8e7f971.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/checkout/en/valu.png
// module id = ./app/images/checkout/en/valu.png
// module chunks = 40